export default __webpack_public_path__ + "static/media/icon-arrow.a5c393d5.svg";